/**
 * Content Slider Component
 * Uses Owl Carousel 2 to create content sliders with previews
 */
(function() {
    // Component implementation
    const ContentSlider = {
        init: function() {
            const $ = jQuery;
            
            // Find all content slider components on the page
            $('.component__content_slider').each(function() {
                const $container = $(this).find('.owl-carousel'); // Target the slider container
                const containerId = $container.attr('id');
                
                // Initialize this specific content slider
                ContentSlider.initSlider($container, containerId);
            });
        },
        
        initSlider: function($container, containerId) {
            const $ = jQuery;
            
            const $customDots = $('#' + containerId + '-dots');
            const $customNav = $('#' + containerId + '-nav');
            const $slides = $container.attr('data-slides');
            
            // Initialize this specific Owl Carousel instance
            $container.owlCarousel({
                loop: false,
                margin: 0,
                center: false,
                autoHeight: false,
                autoplay: false,
                nav: true,
                navContainer: $customNav,
                navClass: ['owl-carousel-prev owl-carousel-nav py-1 px-3 flex items-center justify-center rounded-full border border-gray-200 text-orange-600 hover:bg-orange-600 hover:b-orange-600 hover:text-white transition disabled', 'owl-carousel-prev owl-carousel-nav py-1 px-3 flex items-center justify-center rounded-full border border-gray-200 text-orange-600 hover:bg-orange-600 hover:b-orange-600 hover:text-white transition'],
                navText: ['<i class="fas fa-arrow-left-long text-body-s"></i>', '<i class="fas fa-arrow-right-long text-body-s"></i>'],
                dots: true,
                dotsEach: true,
                dotsContainer: $customDots,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: $slides >= 3 ? 2 : $slides,
                    },
                    980: {
                        items: $slides >= 4 ? 3 : ($slides >= 3 ? $slides : 2),
                    },
                    1280: {
                        items: $slides,
                    },
                }
            });
            
            // Handle window resizing
            $(window).on('resize', function() {
                // Force Owl Carousel to recalculate sizes
                setTimeout(function() {
                    $container.trigger('refresh.owl.carousel');
                }, 200);
            });
        }
    };

    // Initialize on document ready
    jQuery(document).ready(function() {
        ContentSlider.init();
    });
    
    // Make available globally if needed
    window.ContentSlider = ContentSlider;
})();